import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import useLogger from "../util/Logger";
import { useAuth } from "./AuthHook";

const SlaContext = createContext();

const defaultSla = {
  SLA: "SLA999",
  WinterHrs: 0,
  SummerHrs: 0,
};

export default function SlaProvider({ children }) {
  const logger = useLogger();
  const auth = useAuth();
  const [currentSla, setSla] = useState(defaultSla);

  const updateSla = async (siteId, workOrderCategory) => {
    logger.debug(
      "SlaProvider.updateSla",
      `GET field/SLA?siteId=${siteId}&workOrderCategory=${workOrderCategory}`
    );

    try {
      const data = await auth.get(
        encodeURI(
          `field/SLA?siteId=${siteId}&workOrderCategory=${workOrderCategory}`
        )
      );

      logger.debug("SlaProvider.updateSla", `Retrieved data`);

      if (data.length === 0) {
        setSla(defaultSla);
        return defaultSla;
      }

      setSla(data);
      return data;
    } catch (error) {
      logger.debug("SlaProvider.updateSla", `Failed to retrieve data`);
      setSla(defaultSla);
      return defaultSla;
    }
  };

  const getSla = () => currentSla;

  return (
    <SlaContext.Provider
      value={{
        getSla,
        updateSla,
      }}
    >
      {children}
    </SlaContext.Provider>
  );
}

SlaProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useSla = () => useContext(SlaContext);
